import { render, staticRenderFns } from "./ReminderList.vue?vue&type=template&id=75e64bf4"
import script from "./ReminderList.js?vue&type=script&lang=js&external"
export * from "./ReminderList.js?vue&type=script&lang=js&external"
import style0 from "./ReminderList.vue?vue&type=style&index=0&id=75e64bf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports